import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import { db } from "firebase/fbConfig.js";
import { connect } from "react-redux";
import compose from "recompose/compose";
import styles from "assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import SearchIcon from "@material-ui/icons/Search";

import Card from "@material-ui/core/Card";
import TextField from "@material-ui/core/TextField";

import IconButton from "@material-ui/core/IconButton";
import NotificationsIcon from "@material-ui/icons/Notifications";

import Autocomplete from "./Autocomplete";

// const filter = createFilterOptions();

const reps = {
  "JONATHAN": "YNdUS3j6zXZr8XihiCfioyZtyDM2",
  "NICOLE": "tLZ7OOa7WAPEl3gNxlEbJ0xEhWr2",
  "DAKOTA": "nCjRg6gmd8WA432cKBs3k7PQE9p2"
};

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      new: false,
      notifications: [],
      query: "",
      shrink: false
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  shrinkLabel = (e) => {
    this.setState({
      shrink: true,
    });
  };

  unShrinkLabel = (e) => {
    if (e.target.value.length === 0) {
      this.setState({
        shrink: false,
      });
    }
  };

  selectOption = (e) => {
    console.log(e.target.value)
    this.setState({
      query: e.target.value,
    });

      console.log(this.state, this.props);
      
      // if (value) {
      //   db.collection('Collections').doc(this.props.id).set({
      //     rep: value,
      //     repID: reps[value]
      //   }, { merge: true })
      //     .then(() => console.log("Rep set"))
      //     .catch(err => console.log(err));
      // }
  }

  // componentDidMount() {
  //   console.log("Bell mounted with: ", this.props.authUser);

  //   const userObserver = db
  //     .collection("TEST-users")
  //     .doc(this.props.authUser.uid)
  //     .onSnapshot(async (doc) => {
  //       const docData = {
  //         ...doc.data(),
  //         id: doc.id,
  //       };

  //       this.setState({
  //         new: docData.newNotifications ? true : false,
  //       });
  //     });

  //   this.unsubUser = userObserver;
  // }

  render() {
    // console.log(this.state);

    return (
      <div
        style={{
          width: "38%",
          float: "right",
          // margin: `${this.state.searchFocus ? "4px" : "5px"} 0px 5px ${
          //   this.state.searchFocus ? "14px" : "15px"
          // }`,
          // border: `${this.state.searchFocus ? "2px" : "1px"} solid ${
          //   this.state.searchFocus ? "#ff0000" : "#d6d6d6"
          // }`,
          // borderRadius: "30px",
        }}
      >
        {/* <Search
          // style={{
          //   color: "#494949",
          //   fontSize: "1.5rem",
          //   marginBottom: "-8px",
          //   marginLeft: "10px"
          // }}
          className={
            this.props.classes.headerLinksSvg +
            " " +
            this.props.classes.searchIcon
          }
        /> */}
        <Autocomplete
          defaultValue={this.state.query}
          // onChange={(event, newValue) => this.setState({ query: newValue })}
          onSelect={this.selectOption}
          // filterOption={filter}
          // selectOnFocus
          // handleHomeEndKeys
          // name={"Global Search"}
          // id="query"
          classes={this.props.classes}
          options={Object.keys(reps)}
          // getOptionLabel={(option) => option}
          // renderOption={(option) => option}
          // freeSolo
          // fullWidth
          // renderInput={(params) => (
          //   <TextField
          //     {...params}
          //     placeholder="Search"
          //     variant="outlined"
          //     margin="dense"
          //     // onFocus={this.shrinkLabel}
          //     // onBlur={this.unShrinkLabel}
          //     // onChange={(e) =>
          //     //   e.target.value && this.setState({ query: e.target.value })
          //     // }
          //     className={this.props.classes.marginDense}
          //     // InputLabelProps={{
          //     //   shrink: this.state.shrink,
          //     // }}
          //     // FormControlProps={{
          //     //   classes: {
          //     //     marginDense: this.props.classes.marginDense
          //     //   }
          //     // }}
          //     InputProps={{
          //       startAdornment: <SearchIcon />,
          //       classes: {
          //         adornedStart: this.props.classes.adornedStart,
          //         inputAdornedStart: this.props.classes.inputAdornedStart,
          //         root: this.props.classes.root
          //       }
          //     }}
          //   />
          // )}
        />
        {/* <CustomInput
          formControlProps={{
            // className: this.props.classes.top + " " + this.props.classes.search,
            style: {
              width: "75%",
              margin: "0",
              paddingTop: "5px",
              background: "transparent",
            },
          }}
          id="query"
          inputProps={{
            placeholder: "Search",
            disableUnderline: true,
            fullWidth: true,
            onChange: (event) => this.handleChange(event),
            onFocus: (event) => this.handleFocus(event),
            onBlur: (event) => this.handleBlur(event),
            inputProps: {
              "aria-label": "Search",
              className: this.props.classes.searchInput,
            },
          }}
        /> */}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
  };
};

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(Search);



// WEBPACK FOOTER //
// ./src/components/Search/Search.jsx